import MarketManagerAdminApiNetworkRequestConfiguration from '@root/market-manager.admin.joinroot.com/src/api/market-manager-admin-api-network-request-configuration';

export default function getMarketStatusesConfiguration() {
  return new MarketManagerAdminApiNetworkRequestConfiguration({
    endpoint: 'market_statuses',
    method: MarketManagerAdminApiNetworkRequestConfiguration.Methods.GET,
  });
}
